<template>
  <v-navigation-drawer
    v-if="showNavigationDrawer"
    fixed
    color="primary"
    class="elevation-8"
    :width="getNavigationDrawerWidth"
    app
  >
    <v-list-item class="pl-4">
      <v-img
        src="@/assets/img/logo-puebla.png"
        contain
        class="mb-1"
      />
    </v-list-item>
    <v-divider />
    <v-list v-if="muestraMenuEvaluacionesMedicas">
      <v-list-item>
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/evaluaciones_medicas/personal"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-account-group</v-icon>
            </v-btn>
          </template>
          <span>Personal</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/evaluaciones_medicas/expedientes"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-book</v-icon>
            </v-btn>
          </template>
          <span>Expedientes</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <v-list v-if="muestraMenuProgramacion">
      <v-list-item>
        <v-btn
          icon
          class="menu-button mr-3 primary--text"
          to="/programacion/dashboard"
        >
          <v-icon>mdi-home</v-icon>
        </v-btn>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/programacion/expedientes"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-book</v-icon>
            </v-btn>
          </template>
          <span>Expedientes</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <v-list v-if="muestraMenuEvaluacionesPsicologicas">
      <v-list-item>
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/evaluaciones_psicologicas/personal"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-account-group</v-icon>
            </v-btn>
          </template>
          <span>Personal</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item>
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/evaluaciones_psicologicas/expedientes"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-book</v-icon>
            </v-btn>
          </template>
          <span>Expedientes</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <v-list v-if="muestraMenuInvestigacionSocioeconomica">
      <v-list-item v-if="perfil === 'Antecedentes'">
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/investigacion_socioeconomica/antecedentes"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-folder</v-icon>
            </v-btn>
          </template>
          <span>Antecedentes</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="perfil === 'Antecedentes'">
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/investigacion_socioeconomica/solicitudes"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-account-group</v-icon>
            </v-btn>
          </template>
          <span>Solicitudes</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="perfil === 'Validación'">
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/investigacion_socioeconomica/validacion"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-book-check</v-icon>
            </v-btn>
          </template>
          <span>Validación</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="perfil === 'ISE'">
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/investigacion_socioeconomica/ise"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-account-search</v-icon>
            </v-btn>
          </template>
          <span>ISE</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="perfil === 'Antecedentes' || perfil === 'Validación' || perfil === 'ISE'">
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/investigacion_socioeconomica/expedientes"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-folder-account</v-icon>
            </v-btn>
          </template>
          <span>Expedientes</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="perfil === 'Antecedentes'">
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/investigacion_socioeconomica/preregistros"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-folder-home</v-icon>
            </v-btn>
          </template>
          <span>Preregistros</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <v-list v-if="muestraMenuEvaluacionesPoligraficas">
      <v-list-item>
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/evaluaciones_poligraficas/personal"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-account-group</v-icon>
            </v-btn>
          </template>
          <span>Personal</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="perfil === 'Poligrafía'">
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/evaluaciones_poligraficas/expedientes"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-folder-account</v-icon>
            </v-btn>
          </template>
          <span>Expedientes</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <v-list v-if="muestraMenuIntegracion">
      <v-list-item>
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/integracion/personal"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-account-group</v-icon>
            </v-btn>
          </template>
          <span>Personal</span>
        </v-tooltip>
      </v-list-item>
      <v-list-item v-if="perfil === 'Integración'">
        <v-tooltip right>
          <template #activator="{ on, attrs }">
            <v-btn
              icon
              class="menu-button mr-3 primary--text"
              to="/integracion/expedientes"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-folder-account</v-icon>
            </v-btn>
          </template>
          <span>Expedientes</span>
        </v-tooltip>
      </v-list-item>
    </v-list>
    <template #append>
      <v-list>
        <v-list-item class="justify-center">
          <v-tooltip right>
            <template #activator="{ on, attrs }">
              <v-icon
                v-if="isOnline"
                color="success"
                class="blink"
                v-bind="attrs"
                v-on="on"
              >
                mdi-server-network
              </v-icon>
              <v-icon
                v-else
                color="red"
                class="blink"
                v-bind="attrs"
                v-on="on"
              >
                mdi-server-network-off
              </v-icon>
            </template>
            <span>{{ isOnline ? 'Modo centralizado' : 'Modo local' }}</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item class="pl-4">
          <v-tooltip right>
            <template #activator="{ on, attrs }">
              <v-btn
                class="menu-button primary--text"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-face-agent</v-icon>
              </v-btn>
            </template>
            <span>Soporte técnico</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item class="pl-4">
          <v-tooltip right>
            <template #activator="{ on, attrs }">
              <v-btn
                class="menu-button primary--text"
                icon
                v-bind="attrs"
                v-on="on"
                @click="versionDialog = true"
              >
                <v-icon>mdi-information</v-icon>
              </v-btn>
            </template>
            <span>Acerca de</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item class="pl-4">
          <v-tooltip right>
            <template #activator="{ on, attrs }">
              <v-btn
                class="menu-button primary--text"
                icon
                v-bind="attrs"
                to="/launcher"
                v-on="on"
              >
                <v-icon>mdi-apps</v-icon>
              </v-btn>
            </template>
            <span>Ir al launcher</span>
          </v-tooltip>
        </v-list-item>
        <v-list-item class="pl-4">
          <v-tooltip right>
            <template #activator="{ on, attrs }">
              <v-btn
                class="menu-button primary--text"
                icon
                v-bind="attrs"
                v-on="on"
                @click="triggerLogout()"
              >
                <v-icon>mdi-exit-run</v-icon>
              </v-btn>
            </template>
            <span>Cerrar sesión</span>
          </v-tooltip>
        </v-list-item>
      </v-list>
    </template>
    <version-dialog-component
      :active="versionDialog"
      @close="versionDialog = false"
    />
  </v-navigation-drawer>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import VersionDialogComponent from './VersionDialogComponent.vue';

export default {
  components: {
    VersionDialogComponent,
  },

  data() {
    return {
      versionDialog: false,
    };
  },

  computed: {
    ...mapGetters({
      loading: 'getLoader',
      idPersonal: 'getIdPersonal',
      perfil: 'getPerfil',
    }),

    getNavigationDrawerWidth() {
      if (this.loading) {
        return 0;
      }
      return 64;
    },

    showNavigationDrawer() {
      if (
        this.$route.name === 'Portal'
                    || this.$route.name === 'Registro de preaspirante'
                    || this.$route.name === 'Login'
                    || this.$route.name === 'Launcher'
      ) {
        return false;
      } return true;
    },

    muestraMenuEvaluacionesMedicas() {
      if (this.$route.matched.some(({ path }) => path === '/evaluaciones_medicas')) {
        return true;
      } return false;
    },

    muestraMenuProgramacion() {
      if (this.$route.matched.some(({ path }) => path === '/programacion')) {
        return true;
      } return false;
    },

    muestraMenuEvaluacionesPsicologicas() {
      if (this.$route.matched.some(({ path }) => path === '/evaluaciones_psicologicas')) {
        return true;
      } return false;
    },

    muestraMenuInvestigacionSocioeconomica() {
      if (this.$route.matched.some(({ path }) => path === '/investigacion_socioeconomica')) {
        return true;
      } return false;
    },

    muestraMenuEvaluacionesPoligraficas() {
      if (this.$route.matched.some(({ path }) => path === '/evaluaciones_poligraficas')) {
        return true;
      } return false;
    },

    muestraMenuIntegracion() {
      if (this.$route.matched.some(({ path }) => path === '/integracion')) {
        return true;
      } return false;
    },

    isOnline() {
      return Math.random() < 0.5;
    },
  },

  methods: {
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    triggerLogout() {
      this.SET_SNACKBAR_MESSAGE('Cerrando sesión...');
      this.logout();
      this.$router.push('/login');
    },

    openUrl(url) {
      window.open(url, '_blank');
    },
  },
};
</script>
